import moment from "moment"
import path from "path"

const pdfConfig = function(type, object) {

    const presentationDate = moment(object.presentationDate).format("DD/MM/YYYY")

    const content = type === 'table' ? 'presentationTable.html' : 'report.html'

    return {
        content: [
            { path: content }
        ],
        context: {
            decisionBody: object.decisionBody?.name,
            generationDate: moment().format("DD/MM/YYYY"),
            date: presentationDate,
            files: object.liberalityFiles,
            processedFiles: object.liberalityFiles.map(file => {
                if(file.status.id !== 'awaitingDecision') return file
                return {
                    ...file,
                    statusName: 'Prêt à être présenté'
                }
            })
        },
        configuration: {
            landscape: true,
            margin: {
                top: '50px',
                bottom: '100px',
                right: '30px',
                left: '30px',
            },
            header: {
                height: '1cm',
                html: ""
            },
            footer: {
                height: '1cm',
                html: `
                    <div style="font-size: 8px; font-family: Verdana, Arial, sans-serif; width: 100%; padding: 0 50px; display: flex; justify-content: space-between; align-items: center;">
                      <div style="text-align: left;">CNDA</div>
                      <div style="text-align: center; flex-grow: 1;">
                        <span class="pageNumber"></span>/<span class="totalPages"></span>
                      </div>
                      <div style="width: 50px;"><!-- placeholder to balance layout --></div>
                    </div>
                  `
            },
            pdfName: `Présentation du ${object.presentationDate}.pdf`,
            outputInDB: true,
            cssSheet: '',
            templateDir:  path.join(global.appRoot,  global.isProd ? "buildServer/server/models/cnda/liberalityArchive/templates" : "src/server/models/cnda/liberalityArchive/templates")
        }
    }
}

export const generatePresentationTable = async (type, object, context) => {
    return new Promise((resolve, reject) => {
        global.pdf.generatePdf(pdfConfig(type, object, context), (err, file) => {
            if (err) reject(err)
            else resolve(file)
        })
    })

}
